// See https://uihubstg.wcm.collegeboard.org/ui/3.4.0/tables/ for Apricot Table
import React, { useEffect, useLayoutEffect } from 'react'
import { dateDisplayFormat, OverlaySpinner, searchBarFocusState, Table } from '@landscape/ui-lib'
import { get } from 'lodash'
import { GET_HISTORICAL_REPORTS_BY_DI_CODE } from '@landscape/gql'
import { HistoricalFileDownload } from './HistoricalFileDownload'
import { InstitutionInfo } from 'components/etc/InstitutionInfo'
import { setPageCode } from 'contextUtil'
import { useQuery } from '@apollo/client'
import { useSetRecoilState } from 'recoil'

const HistoricalReport = (props: any) => {
  const setSearchBarFocus = useSetRecoilState(searchBarFocusState)
  const historicalReports = useQuery(GET_HISTORICAL_REPORTS_BY_DI_CODE, {
    fetchPolicy: 'cache-and-network',
  })

  useLayoutEffect(() => {
    document.getElementById('report')?.classList.remove('cb-open')
    document.title = 'Landscape - Reports'
    setPageCode('reports')
  }, [])

  useEffect(() => setSearchBarFocus(false), [setSearchBarFocus])

  const historicalFileColumns = [
    { label: 'Report Date', field: 'reportCreatedDate', sortable: false, justify: 'start' },
    { label: 'File Size', field: 'fileSize', sortable: false, justify: 'end' },
    {
      label: 'Report Download Link',
      field: 'fileName',
      addnClasses: 'cb-glyph cb-download',
      extraAttrs: {
        'aria-hidden': 'true',
      },
      sortable: false,
      justify: 'start',
      customComponent: { comp: HistoricalFileDownload, props: {} },
    },
  ]

  if (historicalReports.error) {
    return <div>Error! {historicalReports.error.message}</div>
  }

  const historicalReportsData =
    get(historicalReports.data, 'getHistoricalReportByDiCode.historicalReports') ?? []

  const files: any = []
  historicalReportsData.forEach((data: any) => {
    files.push({
      reportCreatedDate: dateDisplayFormat(data.reportCreatedDate, { unix: true }),
      fileName: data.fileName,
      fileKey: data.fileKey,
      di_code: data.di_code,
      fileSize: data.fileSize,
    })
  })

  return (
    <>
      <InstitutionInfo />

      <div className="container">
        <OverlaySpinner show={historicalReports.loading} id="historical-files-spinner" />
        <div className="cb-margin-bottom-32">
          <h4>Institution Reports</h4>
          <p className="cb-margin-top-16">
            Reports based on your institution's Landscape data uploads.
          </p>
        </div>
        {files.length > 0 && (
          <Table
            id="hist-rpt-table"
            columns={historicalFileColumns}
            condensed
            data={files}
            defaultSortAsc={false}
            pagination={files.length > 25}
            paginationRowPerPage={25}
            uniqueKeyColumn="fileName"
          />
        )}
      </div>
    </>
  )
}

export { HistoricalReport }
